export const Type: any = {
    "A": "Instant Teams",
    "E": "Employer",
    "S": "Seeker",
}